import { useEffect, useLayoutEffect, useState, useRef } from "react"
import { getOrgRealtimeData, getOrgAlarms } from "../../../api/dashboard"
import { getProjectAlarms, getProjectRealtimeData } from "../../../api/dashboard";
import { dateTimeRender, timeRender, textRender } from "../../../utils";
import { Table, TableProps } from "antd";
import { Title } from '../Layouts'
import styles from './index.module.scss';

const TableContainer = ({ tableProps, title, fullScreen }: {
    title: string;
    tableProps: TableProps;
    fullScreen: boolean;
}) => {
    const ref = useRef<any>(null)
    const [hover, setHover] = useState(false);
    useScrollTable(ref, hover, tableProps.dataSource);
    const containerRef = useRef<HTMLDivElement>(null);
    const [scrollerHeight, setScrollerHeight] = useState<number>()
    useLayoutEffect(() => {
        const containerHeight = containerRef.current?.offsetHeight;
        const theadHeight = 26 + 28;
        if (containerHeight) {
            setScrollerHeight(containerHeight - theadHeight)
        }
    }, [fullScreen]);

    const showLoading = !tableProps.dataSource?.length && tableProps.loading;

    return <div
        ref={containerRef}
        onMouseEnter={() => {
            setHover(true)
        }}
        onMouseLeave={() => {
            setHover(false)
        }}
        style={{
            background: 'rgb(9, 53, 99)',
            overflow: 'hidden',
            height: '100%',
        }}>
        <Title>{title}</Title>
        <Table
            ref={ref}
            scroll={{ y: scrollerHeight }}
            className={styles.table}
            pagination={false}
            size="small"
            {
            ...tableProps
            }
            loading={showLoading}
            dataSource={showLoading ? new Array(30).fill(0).map(i => {
                return {}
            }) : tableProps.dataSource}
        />
    </div>
}

export const useScrollTable = (containerRef: any, hover: boolean, dataSource: any) => {
    useEffect(() => {
        if (hover) return;
        const t = setInterval(() => {
            const container = containerRef.current;
            if (container) {
                const scroller = container.nativeElement.querySelector('.ant-table-body') as HTMLDivElement;
                const {scrollHeight, clientHeight} = scroller;
                if (scrollHeight === clientHeight) {
                    clearInterval(t)
                    return; // 数据不足
                }
                const tableBody = container.nativeElement.querySelector('.ant-table-tbody') as HTMLDivElement;
                const tableRowList = tableBody.childNodes;
                const tailNode = tableRowList[tableRowList.length - 1] as HTMLTableRowElement;
                tailNode.classList.add(styles.newRow)
                tableBody.removeChild(tailNode);
                tableBody.insertBefore(tailNode, tableRowList[0]);
            }
        }, 3000);
        if (!dataSource?.length || hover) clearInterval(t);
        return () => {
            clearInterval(t)
        }
    }, [dataSource, hover]);
}

export function Alarms(p: { refreshKey?: number, orgId?: string, projectId?: string, fullScreen: boolean }) {
    const [data, setData] = useState<OrgAlarm[]>([]);
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        if (!p.orgId && !p.projectId) return;
        setLoading(true);
        (
            p.orgId ?
                getOrgAlarms(p.orgId) :
                getProjectAlarms(p.projectId)
        )
            .then(res => {
                setData(res as any)
                setLoading(false)
            })
            .catch((err: Error) => {
                console.error(err)
                setLoading(false)
            })
    }, [p.orgId, p.projectId, p.refreshKey]);
    return (
        <TableContainer
            fullScreen={p.fullScreen}
            title="实时告警"
            tableProps={{
                loading,
                dataSource: data,
                rowKey: 'deviceAlarmInfoId',
                columns: [
                    {
                        key: 'deviceName',
                        dataIndex: 'deviceName',
                        title: '展位号',
                        render: (textRender),
                    },
                    {
                        key: 'deviceSn',
                        dataIndex: 'deviceSn',
                        title: '序列号',
                        width: 70,
                        render: (sn: string) => sn?.slice?.(-5) || '-'
                    },
                    {
                        key: 'description',
                        render: (textRender),
                        dataIndex: 'description',
                        title: '告警信息',
                    },
                    {
                        key: 'receiveDatetime',
                        dataIndex: 'receiveDatetime',
                        title: '接收时间',
                        width: 90,
                        render: timeRender
                    },
                ]
            }
            }
        />
    )
}

export default function Realtime(p: { refreshKey?: number, projectId?: string, orgId?: string, fullScreen: boolean }) {
    const [data, setData] = useState<RealtimeData[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!p.orgId && !p.projectId) return;
        setLoading(true);
        (p.orgId ?
            getOrgRealtimeData(p.orgId)
            :
            getProjectRealtimeData(p.projectId)
        )
            .then(res => {
                setData(res)
                setLoading(false)
            })
            .catch((err: Error) => {
                console.error(err)
                setLoading(false)
            })
    }, [p.orgId, p.projectId, p.refreshKey]);
    return (
        <TableContainer
            fullScreen={p.fullScreen}
            title="实时数据"
            tableProps={{
                loading,
                rowKey: 'deviceRealtimeInfoId',
                dataSource: data,
                columns: [
                    {
                        key: 'deviceName',
                        dataIndex: 'deviceName',
                        title: '展位号',
                        width: 130,
                        render: textRender,
                    },
                    {
                        key: 'switchVoltage',
                        dataIndex: 'switchVoltage',
                        render: (textRender),
                        title: '电压'
                    },
                    {
                        key: 'switchCurrent',
                        dataIndex: 'switchCurrent',
                        render: (textRender),
                        title: '电流'
                    },
                    {
                        key: 'switchTemp',
                        dataIndex: 'switchTemp',
                        render: (textRender),
                        title: '温度'
                    },
                    {
                        key: 'receiveDatetime',
                        dataIndex: 'receiveDatetime',
                        title: '接收时间',
                        width: 80,
                        render: timeRender as any
                    }
                ]
            }
            }
        />
    )
}
